<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Rakodási listák</span>
      <el-button
        v-can="'stowage.create'"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="$router.replace('/sales/stowages/add')"
      >
        Új rakodási lista
      </el-button>
    </div>
    <div
      v-loading="loading"
      style="min-height: 81px;"
    >
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="stowage/fetchAll"
      />
    </div>
    <stowage-list />
    <template v-if="$route.meta.showAddStowageDialog">
      <stowage-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateStowageDialog">
      <stowage-dialog
        :stowage-id="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showStowageViewDialog">
      <stowage-dialog
        :stowage-id="$route.params.id"
        type="view"
      />
    </template>
  </el-card>
</template>

<script>
import stowageList from '../../components/sales/stowages/List';
import stowageDialog from '../../components/sales/stowages/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    stowageList,
    stowageDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'text',
          name: 'cm_delivery_note_number',
          label: 'CM szlev száma',
        },
        {
          type: 'text',
          name: 'order_number',
          label: 'Megrendelésszám',
        },
        {
          type: 'text',
          name: 'delivery_number',
          label: 'Szállítólevélszám',
        },
        {
          type: 'text',
          name: 'customers',
          label: 'Átvevő',
        },
        {
          type: 'text',
          name: 'addresses',
          label: 'Cím',
        },
        {
          type: 'date',
          name: 'created_at',
          label: 'Rögzítés dátuma',
        },
        {
          type: 'date',
          name: 'delivery_date',
          label: 'Szállítás dátuma',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
            {
              label: 'Elküldve',
              status: 'done'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
      ];
    },
  },
};
</script>
